import React, { useState } from 'react';

const ArrowIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" width="12" height="12" aria-hidden="true">
    <path d="M5 3l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MenuIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const NAV_LINKS = [
  { href: '#products', label: 'Products' },
  { href: '#case-studies', label: 'Case studies' },
  { href: '#enterprise', label: 'Enterprise' },
  { href: '#about', label: 'About' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);

  return (
    <header className="nav">
      <div className="container">
        <div className="nav-inner">
          <a href="#top" className="nav-brand" onClick={close}>
            <div className="nav-brand-mark">GA</div>
            <span>Gabriel Alabi</span>
          </a>

          <nav className="nav-links" aria-label="Main navigation">
            {NAV_LINKS.map(l => (
              <a key={l.href} className="nav-link" href={l.href}>{l.label}</a>
            ))}
          </nav>

          <div className="nav-cta">
            <a
              className="btn btn-secondary"
              href="/CV-Gabriel-Alabi.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </a>
            <a className="btn btn-accent" href="#contact">
              Get in touch <ArrowIcon />
            </a>
          </div>

          <button
            className="nav-mobile-toggle"
            onClick={() => setMenuOpen(o => !o)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>

        <div
          className={`nav-mobile-menu${menuOpen ? ' open' : ''}`}
          role="navigation"
          aria-label="Mobile navigation"
        >
          {NAV_LINKS.map(l => (
            <a key={l.href} className="nav-link" href={l.href} onClick={close}>{l.label}</a>
          ))}
          <div className="nav-mobile-cta">
            <a
              className="btn btn-secondary"
              href="/CV-Gabriel-Alabi.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </a>
            <a className="btn btn-accent" href="#contact" onClick={close}>
              Get in touch <ArrowIcon />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
